export default "__VITE_ASSET__BKP5PmP3__"